import * as React from "react";
const SvgFiRrBadgeLeaf = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-badge-leaf_svg__a)">
      <path
        fill="#062147"
        d="M13.478 5.568a2.2 2.2 0 0 0-2.957 0C9.303 6.667 7 9.426 7 11.999a5.01 5.01 0 0 0 4 4.899v1.101a1 1 0 0 0 2 0v-1.101a5.01 5.01 0 0 0 4-4.899c0-2.573-2.303-5.331-3.522-6.431M13 14.815v-3.816a1 1 0 0 0-2 0v3.816a3 3 0 0 1-2-2.816c0-1.63 1.673-3.874 2.861-4.946a.21.21 0 0 1 .278-.001C13.327 8.125 15 10.368 15 11.999a3 3 0 0 1-2 2.816m11-2.816c0-1.626-.714-3.16-1.925-4.124a5.49 5.49 0 0 0-1.59-4.362c-1.15-1.15-2.742-1.727-4.277-1.555A5.49 5.49 0 0 0 12-.001c-1.626 0-3.16.714-4.124 1.925a5.47 5.47 0 0 0-4.362 1.59c-1.15 1.15-1.729 2.74-1.555 4.277A5.49 5.49 0 0 0 0 11.999c0 1.626.714 3.16 1.925 4.124a5.49 5.49 0 0 0 1.59 4.362c1.15 1.15 2.746 1.734 4.277 1.555A5.49 5.49 0 0 0 12 23.999c1.626 0 3.16-.714 4.124-1.925a5.5 5.5 0 0 0 4.362-1.59c1.15-1.15 1.729-2.74 1.555-4.277A5.49 5.49 0 0 0 24 11.999m-3.248 2.679a1.88 1.88 0 0 0-.669 1.617 3.5 3.5 0 0 1-1.012 2.776 3.47 3.47 0 0 1-2.776 1.011 1.89 1.89 0 0 0-1.617.67 3.497 3.497 0 0 1-5.357 0 1.88 1.88 0 0 0-1.616-.669 3.5 3.5 0 0 1-3.787-3.788 1.88 1.88 0 0 0-.67-1.617 3.497 3.497 0 0 1 0-5.357c.479-.404.723-.993.669-1.617a3.497 3.497 0 0 1 3.788-3.787 1.91 1.91 0 0 0 1.617-.67 3.497 3.497 0 0 1 5.357 0c.404.479.997.72 1.617.669a3.496 3.496 0 0 1 3.787 3.788 1.88 1.88 0 0 0 .67 1.617 3.498 3.498 0 0 1-.001 5.357"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-badge-leaf_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBadgeLeaf;
